import { dialog } from '#/components/dialog-kit';
import { toast } from 'sonner';

/**
 * Handles transaction errors by displaying a toast notification.
 * @param {unknown} error - The error object to handle.
 */
export function handleTransactionError(error: unknown) {
  if (process.env.NODE_ENV === 'development') {
    console.log('====================================');
    console.log({ error });
    console.log('====================================');
  }

  const title =
    (error as any).transaction != null ? 'Transaction Error' : 'Error Occurred';

  const fullErrorMessage: string =
    (error as any).reason ||
    (error as unknown as Error).message ||
    'An error occurred';
  toast.error(
    <div className="h-24 break-all overflow-auto">{fullErrorMessage}</div>,
    {
      action: {
        label: 'View Details',
        onClick: () => {
          dialog(
            {
              title,
            },
            <div className="h-96 break-all overflow-auto">
              {fullErrorMessage}
            </div>
          );
        },
      },
      className: 'pointer-events-auto',
    }
  );
}
